import React from "react"
import type {
	CheckPaymentLimits,
	CheckPaymentTotalsDaily,
	CheckPaymentTotalsMonthly,
	CheckPaymentLimitOverrideInfo,
} from "../../../../resources/account"
import {LimitOverrideType} from "../../../../resources/account"
import RangeBox from "../../../../components/RangeBox/RangeBox"
import {LimitsPageBlockHeader} from "../LimitsPageBlockHeader"
import {buildCheckPaymentOverrideInfoProp, getEffectiveCheckPaymentLimit} from "../helpers"

const checkPaymentLimitItems: {
	description: string
	overrideType: LimitOverrideType
	sentLimitKey: "dailySent" | "monthlySent"
	softLimitKey: "dailySentSoft" | "monthlySentSoft"
	totalKey: "totalsDaily" | "totalsMonthly"
}[] = [
	{
		description: "(Daily Limit)",
		overrideType: LimitOverrideType.CheckPaymentDaily,
		sentLimitKey: "dailySent",
		softLimitKey: "dailySentSoft",
		totalKey: "totalsDaily",
	},
	{
		description: "(Monthly Limit)",
		overrideType: LimitOverrideType.CheckPaymentMonthly,
		sentLimitKey: "monthlySent",
		softLimitKey: "monthlySentSoft",
		totalKey: "totalsMonthly",
	},
]

export function CheckPaymentLimitsSection({
	limits,
	total,
	onEditLimit,
	override,
}: {
	limits: CheckPaymentLimits
	total: {totalsDaily: CheckPaymentTotalsDaily; totalsMonthly: CheckPaymentTotalsMonthly}
	onEditLimit?: (limitType: LimitOverrideType) => void
	override?: CheckPaymentLimitOverrideInfo
}) {
	return (
		<div className="account-limits-page-section">
			<LimitsPageBlockHeader title="Check Payment Limits" icon="check-write--business-products" />

			<div className="account-limits-page-grid">
				{checkPaymentLimitItems.map(({description, overrideType, sentLimitKey, softLimitKey, totalKey}) => {
					const sentLimit = limits[sentLimitKey] ?? 0
					return (
						<RangeBox
							key={overrideType}
							title="Sent"
							description={description}
							className="account-limits-page-range-box"
							max={getEffectiveCheckPaymentLimit(sentLimit, override, overrideType)}
							current={total[totalKey].sent}
							softLimit={limits[softLimitKey]}
							onEdit={onEditLimit ? () => onEditLimit(overrideType) : undefined}
							overrideInfo={buildCheckPaymentOverrideInfoProp(override, overrideType, sentLimit)}
						/>
					)
				})}
			</div>
		</div>
	)
}
